import styled from "styled-components";
import { pageMargins } from "@/lib/styles/helpers";

export const Container = styled.div`
  ${pageMargins};

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-row-gap: 3.75rem;
  margin-top: 3.75rem;
  margin-bottom: 3.75rem;

  ${({ theme }) => theme.mediaQueries.laptop} {
    grid-template-columns: repeat(4, 1fr);
    grid-row-gap: 6.25rem;
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }
`;
